import { ConflictMineralCard } from '../../components/conflict-mineral/ConflictMineralCard';
import { ExtendedMineralCard } from '../../components/extended-mineral/ExtendedMineralCard';
import { TpsCard } from '../../components/tps/TpsCard';
import { SurveyPartCard } from '../../components/part-survey/PartSurveyCard';
import { CooCard } from '../../components/coo/CooCard';
import { GenericCard } from '../../components/GenericCard';
import { CRS_SURVEY_CODES, CRS_SURVEY_TEMPLATES} from '../../utils/surveyLiterals';




export default function SurveyFactory(props) {
    if (props.campaign && props.campaign.templateType) {
      switch (props.campaign.templateType) {
        case CRS_SURVEY_TEMPLATES.PART:
          return <SurveyPartCard {...props} />;
      }
    }
    switch (props.code) {
      case CRS_SURVEY_CODES.CM:
        return <ConflictMineralCard {...props} />;
      case CRS_SURVEY_CODES.EM:
        return <ExtendedMineralCard {...props} />;
      case CRS_SURVEY_CODES.TPSMEX:
      case CRS_SURVEY_CODES.TPSUS:
      case CRS_SURVEY_CODES.TPS:
        return <TpsCard {...props} />;
      case CRS_SURVEY_CODES.COO:
        return <CooCard {...props} />;
      case CRS_SURVEY_CODES.TPSMEX:
        return <TpsCard {...props} />;
      default:
        return <GenericCard {...props} />;
    }
  }